import { render, staticRenderFns } from "./storeConstruction.vue?vue&type=template&id=cd858fa4&scoped=true"
import script from "./storeConstruction.vue?vue&type=script&lang=js"
export * from "./storeConstruction.vue?vue&type=script&lang=js"
import style0 from "./storeConstruction.vue?vue&type=style&index=0&id=cd858fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd858fa4",
  null
  
)

export default component.exports